
import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { AiOutlineStar, AiFillStar } from 'react-icons/ai'; // استيراد أيقونات النجمة
import { Link } from 'react-router-dom'; // استيراد Link
import { HubConnectionBuilder } from '@microsoft/signalr';
import { useNavigate } from "react-router-dom";




function ParticipantPage() {
  const [events, setEvents] = useState([]);
  const [user, setUser] = useState(null);
  const [venueQuery, setVenueQuery] = useState('');
  const [dateQuery, setDateQuery] = useState(''); // حالة لتخزين تاريخ البحث
  const [savedEvents, setSavedEvents] = useState([]); // حالة لتخزين معرفات الفعاليات المحفوظة
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const connection = useRef(null);
  const navigate = useNavigate();



  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = JSON.parse(atob(token.split('.')[1]));
        setUser(decoded);
        const userId = decoded?.[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ];
        if (userId) {
          fetchSavedEvents(userId);

        }
      } catch (error) {
        console.error("Error decoding token:", error);
        setUser(null);
      }
    }

    fetchAllEvents();

    // بناء واتصال SignalR
    connection.current = new HubConnectionBuilder()
      .withUrl('https://localhost:7136/notificationHub', {
        accessTokenFactory: () => token,
        withCredentials: true

      })
      .withAutomaticReconnect()
      .build();

    connection.current.on('ReceiveNotification', (notification) => {
      setNotifications(prevNotifications => [notification, ...prevNotifications]);
    });

    connection.current.start()
      .then(() => console.log('SignalR connection started'))
      .catch(err => console.error('Error while starting SignalR connection:', err));

    return () => {
      if (connection.current) {
        connection.current.stop()
          .then(() => console.log('SignalR connection stopped'))
          .catch(err => console.error('Error while stopping SignalR connection:', err));
      }
    };
  }, []);



  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = JSON.parse(atob(token.split('.')[1]));
        setUser(decoded);
        const userId = decoded?.[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ];
        if (userId) {
          fetchSavedEvents(userId);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        setUser(null);
      }
    }

    fetchAllEvents();
  }, []);

  const fetchAllEvents = () => {
    axios.get('https://localhost:7136/api/event')
      .then((response) => {
        setEvents(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the events!", error);
      });
  };

  const fetchSavedEvents = (userId) => {
    axios.get(`https://localhost:7136/api/savedevents/user/${userId}`)
      .then((response) => {
        const savedEventIds = response.data.map(event => event.eventId);
        setSavedEvents(savedEventIds);
      })
      .catch((error) => {
        console.error("Error fetching saved events:", error);
      });
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
        localStorage.removeItem("userId");

   // window.location.href = '/login';
       navigate("/login");

  };

  const handleReserve = async (eventId) => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    if (!token || !user) {
      console.log("يجب تسجيل الدخول للحجز.");
      return;
    }

    try {
      const response = await axios.post('https://localhost:7136/api/registrations/register', { userId, eventId });
      if (response.status === 200) {
        alert(response.data || "تم حجز تذكرتك بنجاح!"); // تم تعديل عرض الرسالة
        // يمكنك هنا تحديث حالة عدد التذاكر المتبقية إذا لزم الأمر
      } else if (response.status === 400 || response.status === 404 || response.status === 409) {
        alert(`حدث خطأ أثناء الحجز: ${response.data?.Message || "يرجى المحاولة مرة أخرى."}`);
      } else {
        alert("حدث خطأ غير متوقع أثناء الحجز. يرجى المحاولة مرة أخرى لاحقًا.");
      }
    } catch (error) {
      console.error("Error registering for event:", error);
      alert("حدث خطأ غير متوقع أثناء الحجز. يرجى المحاولة مرة أخرى لاحقًا.");
      if (error.response) {
        console.log(error.response.data); // عرض تفاصيل الخطأ من الواجهة الخلفية
      }
    }
  };

  const handleSearchByVenue = () => {
    if (!venueQuery.trim()) {
      fetchAllEvents();
      return;
    }

    axios.get(`https://localhost:7136/api/event/get-${venueQuery}`)
      .then((response) => {
        setEvents(response.data);
      })
      .catch((error) => {
        console.error("Error fetching events by venue:", error);
        setEvents([]);
      });
  };

  const handleSearchByDate = () => {
    if (!dateQuery) {
      fetchAllEvents();
      return;
    }

    axios.get(`https://localhost:7136/api/event/date/${dateQuery}`)
      .then((response) => {
        setEvents(response.data);
      })
      .catch((error) => {
        console.error("Error fetching events by date:", error);
        setEvents([]);
      });
  };

  const handleSaveEvent = (eventId) => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');

    if (!token || !user) {
      console.log("يجب تسجيل الدخول لحفظ الفعالية.");
      return;
    }

    axios.post('https://localhost:7136/api/savedevents/save', { userId, eventId })
      .then((response) => {
        setSavedEvents([...savedEvents, eventId]);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error saving event:", error);
        if (error.response && error.response.status === 409) {
          console.log(error.response.data);
        }
      });
  };

  const handleRemoveFromSaved = (eventId) => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');

    if (!token || !user) {
      console.log("يجب تسجيل الدخول لإزالة حفظ الفعالية.");
      return;
    }

    axios.delete('https://localhost:7136/api/savedevents/unsave', { data: { userId, eventId } })
      .then((response) => {
        setSavedEvents(savedEvents.filter((id) => id !== eventId));
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error unsaving event:", error);
        if (error.response && error.response.status === 400) {
          console.log(error.response.data);
        }
      });
  };

  // ✅ دالة التحميل
  const handleDownload = async (fileName) => {
    try {
      const response = await axios.get(`https://localhost:7136/api/event/download/${fileName}`, {
        responseType: 'blob',
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('خطأ أثناء التحميل:', error);
    }
  };


  const fetchUnreadNotifications = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const userIdClaim = user?.[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
      ];

      if (userIdClaim) {
        const response = await axios.get(`https://localhost:7136/api/notification/unread/${userIdClaim}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        setNotifications(response.data);
      } else {
        console.error('User ID not found in token.');
      }
    } catch (error) {
      console.error('Error fetching unread notifications:', error);
    }
  }, [user]);

  const toggleNotificationsVisibility = () => {
    if (!showNotifications) {
      fetchUnreadNotifications();
    }
    setShowNotifications(!showNotifications);
  };

  const markSingleNotificationAsRead = async (notificationId) => {

    try {

      const token = localStorage.getItem('token');
      await axios.post(`https://localhost:7136/api/notification/${notificationId}/read`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      setNotifications(prevNotifications =>
        prevNotifications.filter(notification => notification.notificationId !== notificationId)
      );
    } catch (error) {
      console.error(`Error marking notification ${notificationId} as read:`, error);
    }
  };

  const markAllNotificationsAsRead = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post('https://localhost:7136/api/notification/read-all', {}, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      setNotifications([]);
      setShowNotifications(false);
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
    }
  };











  return (
    <div className="min-h-screen bg-cover bg-center flex flex-col items-center justify-start p-4"
      style={{ backgroundImage: `url('./images/photo3.jpg')` }}>

      <div className="w-full flex flex-col items-center justify-center py-10 space-y-4">
        <h1 className="text-5xl text-white font-extrabold shadow-lg transform transition-all duration-300 hover:scale-110 font-custom">
          الفعاليات المتاحة
        </h1>

        <div className="text-white flex items-center space-x-4 rtl:space-x-reverse">
          <span>{user?.FullName || user?.fullName}</span>
          <Link to="/saved" className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg font-bold transition">
            المحفوظات
          </Link>
          <Link to="/registrations" className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-bold transition">
            تسجيلاتي
          </Link>

          <button
            onClick={toggleNotificationsVisibility}
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-bold transition"
          >
            الإشعارات ({notifications.filter(n => !n.isRead).length})
          </button>

          <button
            onClick={handleLogout}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-bold transition"
          >
            تسجيل الخروج
          </button>
        </div>

        {/* قسم البحث مع حقل التاريخ */}
        <div className="mt-4 flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-2 rtl:space-x-reverse">
          <input
            type="text"
            value={venueQuery}
            onChange={(e) => setVenueQuery(e.target.value)}
            placeholder="ابحث باسم المكان"
            className="px-4 py-2 rounded-lg shadow-md focus:outline-none"
          />
          <button
            onClick={handleSearchByVenue}
            className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded-lg transition"
          >
            بحث بالاسم
          </button>

          <input
            type="date"
            value={dateQuery}
            onChange={(e) => setDateQuery(e.target.value)}
            className="px-4 py-2 rounded-lg shadow-md focus:outline-none"
          />
          <button
            onClick={handleSearchByDate}
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg transition"
          >
            بحث بالتاريخ
          </button>
        </div>
      </div>

      <div className="w-full max-w-screen-lg mt-6">
        {events.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {events.map((event) => {
              const mediaUrl = `https://localhost:7136/Uploads/${event.mediaFileName}`;
              const isVideo = event.mediaFileName?.match(/\.(mp4|mov|avi|webm)$/i);
              const isEventSaved = savedEvents.includes(event.eventId); // التحقق إذا كانت الفعالية محفوظة

              return (
                <div
                  key={event.eventId}
                  className="bg-white p-6 rounded-2xl shadow-xl transition-transform transform duration-300 hover:scale-105 hover:shadow-2xl hover:-translate-y-2 cursor-pointer relative" // إضافة relative هنا
                >
                  {/* أيقونات الحفظ والإزالة من الحفظ */}
                  <div className="absolute top-2 left-2 flex flex-col items-center">
                    {isEventSaved ? (
                      <AiFillStar
                        className="text-yellow-500 text-2xl cursor-pointer"
                        onClick={() => handleRemoveFromSaved(event.eventId)}
                      />
                    ) : (
                      <AiOutlineStar
                        className="text-gray-400 hover:text-yellow-500 text-2xl cursor-pointer"
                        onClick={() => handleSaveEvent(event.eventId)}
                      />
                    )}
                  </div>

                  {isVideo ? (
                    <div className="relative w-full rounded-md overflow-hidden mb-4 aspect-video">
                      <video
                        controls
                        className="absolute top-0 left-0 w-full h-full object-cover rounded-md"
                      >
                        <source src={mediaUrl} type="video/mp4" />
                        متصفحك لا يدعم تشغيل الفيديو.
                      </video>
                    </div>
                  ) : (
                    <a href={mediaUrl} download>
                      <img
                        src={mediaUrl}
                        alt="Event Media"
                        className="w-full h-40 object-cover rounded-md mb-4 cursor-pointer"
                      />
                    </a>
                  )}

                  {/* زر التحميل */}
                  <button
                    onClick={() => handleDownload(event.mediaFileName)}
                    className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-4 rounded mb-3 transition"
                  >
                    تحميل الوسائط
                  </button>
                  <h3 className="text-2xl font-bold text-gray-800 mb-2 font-custom">{event.title}</h3>
                  <p className="text-gray-600 mb-2 font-custom">{event.description}</p>
                  <p className="text-gray-800 font-custom">Organizer Name: {event.organizerName}</p>
                  <p className="text-gray-800 font-custom">Venue: {event.venue}</p>
                  <p className="text-gray-800 font-custom">
                    Event Date: {new Date(event.eventDatetime).toLocaleDateString()}
                  </p>
                  <p className="text-gray-800 font-custom">Ticket Price: {event.ticketPrice} EGP</p>
                  <p className="text-gray-800 font-custom">Number of Tickets Left: {event.numberofTicketsLeft}</p>
                  <p className="text-gray-800 font-custom">Number of Participants Submitted: {event.numberofParticipantsSubmitted}</p>

                  <button
                    onClick={() => handleReserve(event.eventId)}
                    className="mt-4 w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-2 px-4 rounded-xl transition"
                  >
                    احجز تذكرتك
                  </button>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-white text-xl font-custom text-center mt-6">لا توجد فعاليات حالياً.</p>
        )}
      </div>
      {showNotifications && (
       // <div className="absolute top-full mt-2 right-0 bg-white text-gray-800 rounded-md shadow-lg p-4 w-80 z-10">
       <div className="absolute top-[5%] mt-2 right-0 bg-white text-gray-800 rounded-md shadow-lg p-4 w-80 z-10">

          {notifications.length === 0 ? (
            <p>لا يوجد إشعارات.</p>
          ) : (
            <div>
              {notifications.map(notification => (
                <div key={notification.notificationId} className="border-b py-2 last:border-b-0">
                  <p>{notification.message}</p>
                  <button
                    onClick={() => markSingleNotificationAsRead(notification.notificationId)}
                    className="bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded text-sm mt-1"
                  >
                    قرأت
                  </button>
                </div>
              ))}
              {notifications.filter(n => !n.isRead).length > 0 && (
                <button
                  onClick={markAllNotificationsAsRead}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded text-sm mt-2"
                >
                  قرأت الكل
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ParticipantPage;


